import { useEffect } from "react"
import { Box, IconButton, InputAdornment, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import Iconify from "minimals-template/components/Iconify"
import { useCleanDebouncedValue } from "routes/facilities/plugins/helpers/use-clean-debounced-value"

export function LibrarySearchBox({ value, onChange, placeholder = "Search...", autoFocus = true }) {
    const [search, setSearch] = useCleanDebouncedValue(value, 500, onChange)

    // The debounced hook only seeds from `value` on mount, so mirror later external changes
    // (e.g. the search being cleared when a folder or task is opened). Intentionally keyed on
    // `value` only — depending on `search` would reset the input mid-typing.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(syncExternalValue, [value])

    return (
        <Box py={0} width={1}>
            <TextField
                className="search-param-box"
                data-cy="library-search-box"
                fullWidth
                value={search}
                autoFocus={autoFocus}
                onChange={setFromEvent(setSearch)}
                variant="standard"
                sx={{ "& .MuiInputBase-input": { fontSize: "1rem", py: 1 } }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Iconify icon="eva:search-fill" sx={{ color: "text.disabled" }} />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                onClick={() => setSearch("")}
                                data-cy="clear-search-button"
                                aria-label="Clear search"
                            >
                                <Iconify icon="ic:round-clear" />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                placeholder={placeholder}
            />
        </Box>
    )

    function syncExternalValue() {
        if (value !== search) setSearch(value)
    }
}
